import React, { useState, useEffect } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./UserManagement.css"; 
import Layout from "../../components/layout";

const UserManagement = () => {
  const [users, setUsers] = useState([]);

  // Fetch users from the API
  const fetchUsers = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/users`);
      const data = await response.json();
      setUsers(data);
    } catch (error) {
      toast.error("Fehler beim Abrufen der Benutzer.");
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  const updateUserRoleToWorker = async (id) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/users/${id}/role/worker`,
        { method: "PUT" }
      );
      if (!response.ok) throw new Error("Fehler beim Aktualisieren der Benutzerrolle auf Worker");

      const data = await response.json();
      toast.success(`Benutzer ${data.user.username} ist jetzt ein Worker.`);
      fetchUsers();
    } catch (error) {
      toast.error("Fehler beim Aktualisieren der Benutzerrolle.");
    }
  };

  const updateUserRoleToAdmin = async (id) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/users/${id}/role/admin`,
        { method: "PUT" }
      );
      if (!response.ok) throw new Error("Fehler beim Aktualisieren der Benutzerrolle auf Admin");

      const data = await response.json();
      toast.success(`Benutzer ${data.user.username} ist jetzt ein Admin.`);
      fetchUsers();
    } catch (error) {
      toast.error("Fehler beim Aktualisieren der Benutzerrolle.");
    }
  };

  const updateUserRoleToUser = async (id) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/users/${id}/role/user`,
        { method: "PUT" }
      );
      if (!response.ok) throw new Error("Fehler beim Zurücksetzen der Benutzerrolle auf User");

      const data = await response.json();
      toast.success(`Benutzer ${data.user.username} ist jetzt wieder ein User.`);
      fetchUsers();
    } catch (error) {
      toast.error("Fehler beim Zurücksetzen der Benutzerrolle.");
    }
  };

  const deleteUser = async (id) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/users/${id}`, {
        method: "DELETE",
      });
      if (!response.ok) throw new Error("Fehler beim Löschen des Benutzers");

      const data = await response.json();
      toast.success(`Benutzer ${data.deletedUser.username} wurde erfolgreich gelöscht.`);
      fetchUsers();
    } catch (error) {
      toast.error("Fehler beim Löschen des Benutzers.");
    }
  };

  return (
    <Layout>
      <div className="Bottom Top">
        <div className="Bottom12">
          <ToastContainer
            position="top-right"
            autoClose={3000}
            hideProgressBar={true}
            closeOnClick
            pauseOnHover
            style={{ width: "250px", fontSize: "14px" }}
          />
          <div className="user-management-container">
            <h2>Benutzerverwaltung</h2>
            <ul className="user-list">
              {users.length > 0 ? (
                users
                  .filter((user) => user.user_id !== 1) // Hide user with user_id 1
                  .map((user) => (
                    <li key={user.user_id} className="user-item">
                      <div className="user-details">
                        <h3>
                          {user.name} {user.lastname}
                        </h3>
                        <p>Email: {user.email}</p>
                        <p>Rolle: {user.role}</p>
                      </div>

                      <div className="user-actions">
                        {user.user_id !== 2 && ( // Make user with user_id 2 non-editable
                          <>
                            {user.role !== "worker" && (
                              <button
                                className="user-action-button"
                                onClick={() => updateUserRoleToWorker(user.user_id)}
                              >
                                Zu Worker machen
                              </button>
                            )}
                            {user.role !== "admin" && (
                              <button
                                className="user-action-button"
                                onClick={() => updateUserRoleToAdmin(user.user_id)}
                              >
                                Zu Admin machen
                              </button>
                            )}
                            {(user.role === "worker" || user.role === "admin") && (
                              <button
                                className="user-action-button"
                                onClick={() => updateUserRoleToUser(user.user_id)}
                              >
                                Zu User zurücksetzen
                              </button>
                            )}
                            <button
                              className="user-delete-button"
                              onClick={() => deleteUser(user.user_id)}
                            >
                              Benutzer löschen
                            </button>
                          </>
                        )}
                      </div>
                    </li>
                  ))
              ) : (
                <p>Keine Benutzer verfügbar</p>
              )}
            </ul>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default UserManagement;
